import React from 'react'

const CoverPage = ({ data, theme, crmSnapshot }) => {
  return (
    <div className="proposal-cover">
      <div className="proposal-cover__accent-bar" />
      <div className="proposal-cover__body">
        {theme?.logoUrl && (
          <div className="proposal-cover__logo">
            <img src={theme.logoUrl} alt="Company Logo" style={{ maxWidth: theme?.logoWidth || 160 }} />
          </div>
        )}
        <div className="proposal-cover__subtitle">{data?.subtitle || 'Landscape Maintenance Proposal'}</div>
        <div className="proposal-cover__divider" />
        <div className="proposal-cover__title">{data?.tagline || 'Professional Landscape Services'}</div>
        <div style={{ height: 48 }} />
        <div className="proposal-cover__client">
          <div className="proposal-cover__client-name">{crmSnapshot?.clientName || 'Client Name'}</div>
          {crmSnapshot?.contactName && <div>Prepared for {crmSnapshot.contactName}</div>}
          {crmSnapshot?.contractDate && <div>{crmSnapshot.contractDate}</div>}
        </div>
      </div>
      <div className="proposal-cover__footer">
        {crmSnapshot?.yourCompany || ''} {crmSnapshot?.yourName ? `| ${crmSnapshot.yourName}` : ''} {crmSnapshot?.yourEmail ? `| ${crmSnapshot.yourEmail}` : ''}
      </div>
    </div>
  )
}

export default CoverPage
